module.exports = __webpack_public_path__ + "static/img/KnottyPromo-01.7be4d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/KnottyPromo-01.png
// module id = 9dDv
// module chunks = 1